import React, {Component} from 'react';
import SecondServer from '../database/SecondServer'
import { urlSwapDcap, urlSiteFactoryCfg } from '../database/apiUrls';
import { TitleRow, RowOfChildren, GridText, newSortIndicators, clickToTableTarget, 
  clickToNamedClass, formatTable, coreSort, toVolts, flipIndicator, flipSort} from "./RenderHelpers";
import DeviceEdit from './Controls/DeviceEdit'
import DeviceDecommission from './Controls/DeviceDecommission';
import { siteAccessCode, siteName, siteLastContact } from '../database/apiv2SiteAccessor';
import {addDevice, decommission, setDeviceInfo, setNewSensorInfo} from '../database/apiDevices'
import {objToCSV, csvExport, csvFileName, updateCSVCol, csvFormat} from '../csv/csvExport'
import {nestedProp} from '../Utils/object'
import csvImport from '../csv/csvImport'
import NoResults from '../Alert/NoResults'
import Search from '../Search/Search'
import FilterRender from '../Search/FilterRender'
import ButtonBar2 from './Controls/ButtonBar2'
import CsvButton5 from './Controls/CsvButton3';
import FileImport from '../FileImport/FileImport'
import Popup from '../Alert/Popup'
import GridAction from './Controls/GridAction'
import SwapDevice from './Controls/SwapDevice'
import SwapDCAP from './Controls/SwapDCAP'
import { isDCAPRadioId, isDCAPRadio, isRepeaterRadio,  } from './Model/DeviceType'
import { cachedPerms, canWrite } from "../Overview/SitePerms";
import { renderLoader } from "../Loading/loading";
import { getIcons, nameToIcon } from "./Controls/DeviceIcons";
import { ContactIndicator } from '../Decorators/Checkmarks';
import {isDeviceId} from './Model/isType'
import {TryAgain} from '../Alert/CommonNotices'
import { readBigConfig, cacheBigConfig, getBigConfig } from '../Sites/SiteConfig';

// available reports
import jsonReportCfg from './reportcfg';
import './report.css'
import './Controls/buttonbar.css'
import '../Decorators/Checkmarks.css'
import "./ConfigSensor.css"


export default class ConfigSensor extends Component {
  constructor(props) {
    super(props);

    //this.reportId = this.props.location.pathname.split("/").pop();
    this.reportId = "config"
    var arrSort = newSortIndicators(jsonReportCfg.data[this.reportId].displayOrder.length);
    this.deviceEditMap = [{from: "apt" , to: "apt"}, 
      {from: "building" , to:"building" }, {from: "node_id", to: "node_id"},
      {from: "location_note", to:"location_note"}, {from: "address", to: "address"}]
    this.csvTitle = ["Radio ID","Type","Sensor Type","Sensor","Node ID",
                    "Address", "Building","Apt","Location Note", "Count Factor",
                     "Units","Meter Type","Meter Style","Meter Note", 
                     "Meter Serial Number","Initial Meter Reading","Initial Meter Time",]
    this.csvTemplate = ["device_id", "type", "sensors.0.display_type", "", "node_id", 
                      "address", "building", "apt", "location_note", "sensors.0.factor",
                      "sensors.0.units", "sensors.0.meter_type", "sensors.0.meter_style", "sensors.0.note", 
                      "sensors.0.meter_serial_number", "sensors.0.initial_meter_read", "sensors.0.initial_meter_time"]
    this.csvRptrTemplate = ["device_id", "type", "", "", "node_id", 
                            "address", "building", "apt", "location_note", ]
    this.csvAdds = [{index: 3, value:"1"}]
    this.csvFormat= ["quoted",'','','','quoted', 'quoted']
    this.deviceDecommissionMap = []
    this.alreadyIn = 0
    this.csvAdded = 0
    this.csvIssue = []
    this.ss = new SecondServer(props)

    this.state = {
      report: [],
      formatReport: null,
      siteDetails: null,
      errorMsg: null,
      lastSort: '', 
      colSort: arrSort,
      batteryFormat: 0,
      isLoading: true,
      loader: renderLoader(),
      editModal: false,
      deviceToEdit: undefined,
      decommissionModal: false,
      deviceToDecommission: undefined,
      swapDevice: undefined,
      swapModal: false,
      csvBanner: false,
      csvDetails: false,
      csvErr: false,
      csvErrMsg: '',
      csvInProg: false,
      csvAdds: 0,
      swapComplete: false,
      newAC: undefined,
      rerender: 0,
      sysInfo: false,
      sysCfg: [],
    };
    this.deviceStatus = undefined;
    this.cancelPoll = new AbortController()
    this.csvImport = new csvImport();
    this.unmounting = false
    this.sort = this.sort.bind(this);
    this.importToggle = this.importToggle.bind(this);
    this.importController = this.importController.bind(this);
    this.refresh = this.refresh.bind(this)
    this.isCommissioned = this.isCommissioned.bind(this)
    this.swap = this.swap.bind(this)
    this.confirmed = this.confirmed.bind(this)
    this.onEdit = this.onEdit.bind(this)
    this.onEditHide = this.onEditHide.bind(this)
    this.onDecommission = this.onDecommission.bind(this)
    this.onDecommissionHide = this.onDecommissionHide.bind(this)
    this.onSwap = this.onSwap.bind(this)
    this.onSwapHide = this.onSwapHide.bind(this)
    this.onSwapDcap = this.onSwapDcap.bind(this)
    this.exportController = this.exportController.bind(this)
    this.csvDone = this.csvDone.bind(this)
    this.newSiteNav = this.newSiteNav.bind(this)
    this.csvShowDetails = this.csvShowDetails.bind(this)
    this.csvClearErr = this.csvClearErr.bind(this)
  }

  async fetchData() {
    // const { match: { params } } = this.props;
    if (!this.state.isLoading) 
      this.setState({isLoading: true});

    const site = this.props.getActiveSite();
    if (!this.deviceStatus) {
      const pr1 = getIcons ({...this.props, ss: this.ss, ac: siteAccessCode(site)})
      pr1.then((result) => {this.deviceStatus = result?.data})
    }
    // const resp = fetchConfig(siteAccessCode(site), this.props)
    if (!site?.site_details?.devices) {
      const json = await this.fetchNew()
      return cacheBigConfig(this.props, json)
    }
    return undefined
  }

  async fetchNew () { 
    //const resp = await fetchConfig(siteId, this.props);
    //return resp?.jsonResponse?.data
    const url = await getBigConfig(this.props, this.ss, this.cancelPoll)
    const json = await readBigConfig (url, this.cancelPoll)
    return json
  }
  formatAPI (apiData) {
    const displayCopy = toVolts(apiData.slice(),"LatestLinkStatusData.BattVolt")
    return formatTable (displayCopy, "device_id", this.props.radioFormat());
  }
  setData(apiResp) {
    const devices = apiResp?.devices
    if (devices) {
      coreSort (devices, "device_id")
      //this.sortData(devices, "device_id")
      this.mergeApiIcons(devices)
      const format = this.formatAPI(devices)
      this.setState( {report: devices, formatReport: format, 
        siteDetails:apiResp?.site_details} );
    }
    this.setState({isLoading: false})
  }
  mergeApiIcons (dispData) {
    const status = this.deviceStatus?.icons
    if (status) {
      dispData.forEach (i=> 
        i.apiIcon = status.find(s=>s.device_id.toUpperCase() === i.device_id.toUpperCase())?.icon)  
    }
  }

  async componentDidMount() {
    let fuglyCfg = 0
    try {
      const site = this.props.getActiveSite()
      if (site?.site_details?.devices) {
        // console.log ("using cached device details")
        this.setData (site.site_details)
        fuglyCfg = site?.site_details?.devices?.length
      }
      else {
        //console.log ('fetching new device details!')
        const json = await this.fetchNew()
        cacheBigConfig(this.props, json)
        this.setData(json)
        fuglyCfg = json?.devices?.length ?? 0
      }
      if (!this.deviceStatus) {
        const pr1 = getIcons ({...this.props, ss: this.ss, ac: siteAccessCode(site)})
        pr1.then((result) => {
          this.deviceStatus = result?.data
          this.setState({rerender: this.state.rerender+1, isLoading: false})
        })
      }

      if (fuglyCfg < 800) {
        const url = urlSiteFactoryCfg (siteAccessCode(site))
        this.ss.apiData(url).then ((resp) => {
          const cnfg = resp?.data?.data?.factory_cnfg
          this.setState({sysCfg: cnfg})
        })
      }
    }
    catch (e) {
      if (!this.unmounting)
        this.setState({isLoading: false})
      console.log (e)
      console.trace()
    }
  }
  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.radioStyle !== this.props.radioStyle) {
      this.setState({formatReport: this.formatAPI(this.state.report)})
    }
    if (this.props?.update && prevProps.update < this.props.update)
      this.componentDidMount()
  }
  componentWillUnmount() {
    this.unmounting = true
    this.cancelPoll.abort("User cancelled request")
  }
  async refresh (){
    const resp = await this.fetchData();
    this.setData(resp);
  }
  isCommissioned(deviceId) {
    return this.state.report.find (item => item.device_id.toLowerCase() === deviceId.toLowerCase())
  }
  //click handler for title row
  sort(e) {
    const targ = clickToTableTarget(e);
    if (jsonReportCfg.data[this.reportId]?.sortable[targ.cellIndex] === false) 
      return;
    if ("id" in targ) {
      const column = targ.id.trim();
      const arrSort = flipIndicator (targ, this.state.colSort, this.state.lastSort)
      flipSort(this.state.formatReport, column, this.state.lastSort)
      this.setState ({ lastSort: column, colSort: arrSort});
    }
  }
  filter = (search) => {
    const arrData = this.state?.report.slice(0);
    if (search.length === 0) {
      //const display = formatTable (arrData, "device_id", this.props.radioFormat());
      //this.setState({filterReport: arrData, formatReport: display});
      this.setState({formatReport: this.formatAPI(this.state.report)})
    }
    else { 
      const usearch = search.toUpperCase();
      const arrFilter = arrData.filter (item => {
        let retcode = false;
        Object.keys(item).forEach(function(key,index) {
          if (typeof(item[key]) === 'string') { 
            retcode |= item[key].toUpperCase().indexOf(usearch) !== -1
          }
        });
        return retcode;
      });
      //const display = formatTable (arrFilter, "device_id", this.props.radioFormat());
      //this.setState({filterReport: arrFilter, formatReport: display});
      this.setState ({formatReport: this.formatAPI(arrFilter)})
    }
  }
 
  //{"TargetAC":"10470901312","type":"MDT","node_id":"Json Demo","address":"","building":"Garage","apt":"5798P ","auto_cnfg_upd":"False","location_note":"2020-12-01"}
  async save (item) {
    const ac=siteAccessCode(this.props.getActiveSite());
    const url = '/tehama/sites/devices/'+item.device_id+"?access_code="+ac;
    var saveObj = {
      "TargetAC":ac,
      "type": item.type,
      "node_id": item.node_id,
      "building": item.building,
      "apt": item.apt
    };
    this.apiSave(saveObj, url);
  }

  async apiSave(saveObj, url) {
    const jsonData = JSON.stringify(saveObj);
    //console.log (jsonData);
    await this.ss.apiSaveData (url, jsonData);
    this.setState ( {errorMsg: this.ss.getErrorMsg() } );
  }

  // for meter model, imr and units
  //{"sensor_type":"51","display_type":"Pulse_Totalizer_1","mon_pt":"0","units":"Liters","meter_type":"G",
  // "meter_style":"O","note":"Gas Meter","meter_serial_number":"123","initial_meter_read":"0",
  // "initial_meter_time":"","factor":"1"}
  async save_meter (item) {
    const si=0;
    const ac=siteAccessCode(this.props.getActiveSite());
    const url = '/tehama/sites/devices/'+item.device_id+"/sensors/"+si+"?access_code="+ac;
    var saveObj = {
      ...(item?.sensors[si]?.units?.length>=0 && {"units": item.sensors[si].units}),
      ...(item?.sensors[si]?.meter_type && {"meter_type": item.sensors[si].meter_type}),
      ...(item?.sensors[si]?.initial_meter_read && {"initial_meter_read": item.sensors[si].initial_meter_read})
    };
    if (Object.keys(saveObj).length) {
      const jsonData = JSON.stringify(saveObj);
      //console.log (jsonData);
      await this.ss.apiSaveData (url, jsonData);
      this.setState ( {errorMsg: this.ss.getErrorMsg() } );
    }
  }
  alreadyCommissioned(deviceId) {
    if (this.state.report.findIndex(item=>item.device_id.toUpperCase() === deviceId.toUpperCase()) > -1) {
      this.setState({errorMsg: "Device " +deviceId + " is already commissioned"})
      return true
    }
    return false
  }
  async swap (newDevice, isCommissioned) {
    const siteId = siteAccessCode(this.props.getActiveSite());
    const table = this.state.formatReport
 
    try {
      if (this.alreadyCommissioned(newDevice))
        return
      this.setState({isLoading: true})
      this.ss.throwOnError (await addDevice (siteId, newDevice, this.ss), "Add device API")
      const oldDevice = table[this.state.swapDevice]
      const apiInfo = {
        node_id: oldDevice?.node_id ?? '',
        address: oldDevice?.address ?? '',
        building: oldDevice?.building ?? '',
        apt: oldDevice?.apt ?? '',
        location_note: oldDevice?.location_note?? '',
      }
      this.ss.throwOnError(await setDeviceInfo (siteId, newDevice, apiInfo, this.ss), "Set up device")
      const arrSensor = this.getSensors(oldDevice?.sensors, [0,1,2])
      /* isCommissioned ? 
        ss.throwOnError (await setSensorInfo (siteId, newDevice, arrSensor, ss), "Copy sensors") :*/
      await setNewSensorInfo(siteId, newDevice, arrSensor, this.ss)
      this.ss.throwOnError (await decommission(oldDevice?.device_id, siteId, this.ss), "Decommission old MDT")
      this.setState({isLoading: false})
      this.refresh()     
    }
    catch(err) {
      this.setState({isLoading: false, errorMsg: err.message})
    }
  }
  getSensors(sensors, arrSensor) {
    if (!sensors?.length) return []
    return arrSensor.map (item => ({
        meter_type: sensors[item]?.meter_type ??'' ,
        meter_style: sensors[item]?.meter_style ?? '',
        units: sensors[item]?.units ?? '',
        factor: sensors[item]?.factor ?? '',
        initial_meter_read: sensors[item]?.initial_meter_read ?? '',
        initial_meter_time: sensors[item]?.initial_meter_time ?? '',
        meter_serial_number: sensors[item]?.meter_serial_number ?? '',
        note: sensors[item]?.note ?? '',
        mon_pt: sensors[item]?.mon_pt,
        sensor_type: sensors[item]?.sensor_type,
        display_type: sensors[item]?.display_type,
      })
    )
  }
  importToggle() {
    document.getElementById('fileImport')?.click();
  }

  async sendCSVtoServer(data) {
    const arrJson = this.csvImport.mapToAPI(data)
    const site = siteAccessCode(this.props.getActiveSite());
    for (const json of arrJson) {
      if (json?.device_id && json?.type?.toUpperCase() !== 'DCAP') {
        if (!this.state.report.some(item => item?.device_id?.toUpperCase() === json?.device_id?.toUpperCase())) {
          //console.log ("add device branch on", json.device_id)
          if (isDeviceId(json?.device_id)) {
            await addDevice(site, json.device_id, this.ss)
            if (this.ss.getErrorMsg()){
              this.csvIssue.push(json.device_id)
              continue;
            }
            this.csvAdded++
          }
        }
        else
          this.alreadyIn++
        const apiInfo = {
          node_id: json?.node_id ?? '',
          address: json?.address ?? '',
          building: json?.building ?? '',
          apt: json?.apt ?? '',
          location_note: json?.location_note?? '',
        }
        await setDeviceInfo (site, json.device_id, apiInfo, this.ss)
        if (isRepeaterRadio(json, "device_id"))
          continue;
        const sensorInfo = [{
          meter_type: json["sensors.0.meter_type"] ??'' ,
          meter_style: json["sensors.0.meter_style"] ?? '',
          units: json["sensors.0.units"] ?? '',
          factor: json["sensors.0.factor"] ?? '',
          initial_meter_read: json["sensors.0.initial_meter_read"] ?? '',
          initial_meter_time: json["sensors.0.initial_meter_time"] ?? '',
          meter_serial_number: json["sensors.0..meter_serial_number"] ?? '',
          note: json["sensors.0.note"] ?? '',
          display_type: json["sensors.0.display_type"],
        }]
        await setNewSensorInfo(site, json.device_id, sensorInfo, this.ss)
      }
    }
  }
  importValidate (data) {
    const issues = this.csvImport.checkFileCols(data)
    if (issues && issues.length) {
      const go = window.confirm (
        "This file may not import the way you want. These columns: "+issues + " are unrecognized. Proceed anyway?")
      return go
    }
    const susRows = this.csvImport.checkDeviceId(data)
    if (susRows && susRows.length) {
      window.alert ("The Radio ID on line(s) "+ susRows + " cannot be imported. We need 8 characters from A-F or 0-9 only")
      return false
    }
    return true
  }
  async importController(data) {
    if (!this.importValidate(data))
      return
    this.setState({isLoading: true, csvErr: false, csvErrMsg: '', csvInProg: true})
    try {
      await this.sendCSVtoServer(data)
    }
    catch (err) {
      this.setState({csvErr: true, csvErrMsg: err.toString()})
    }
    finally {
      this.setState({csvInProg: false, isLoading: false, csvBanner: true})
      await this.refresh()
    }
  }
  csvDone() {
    this.alreadyIn =0
    this.csvAdded = 0
    this.csvIssue = []
    this.setState({csvBanner: false, csvDetails: false, csvAdds:0})
    this.csvImport = new csvImport()
  }
  csvClearErr() {
    this.setState({csvErr: false, csvErrMsg: ''})
  }
  exportController () {
    const fname = csvFileName("Config_"+siteName(this.props.getActiveSite()))
    const mdt = this.csvFilter(this.state.formatReport)
    let temp = objToCSV(mdt, this.csvTemplate)
    if (temp) {
      temp = updateCSVCol(temp, this.csvAdds[0].index, this.csvAdds[0].value)
    }
    const rptr = this.rptrFilter(this.state.formatReport)
    const rptrTemp = objToCSV(rptr, this.csvRptrTemplate)
    if (temp && rptrTemp)
      temp = temp.concat(rptrTemp)
    const csvData = csvFormat(temp, this.csvFormat)
    csvData.unshift(this.csvTitle)
    csvExport (fname, csvData);
  }
  csvFilter(data) {
    return data.filter(i=> !(isDCAPRadio(i, 'device_id')||isRepeaterRadio(i, 'device_id')))
  }
  rptrFilter(data) {
    return data.filter(i => isRepeaterRadio(i, 'device_id'))
  }
  confirmed() {
    this.setState({errorMsg: ''})
    this.refresh();
  }
  onSwap (evt) {
    const btn=clickToNamedClass(evt, "actButton")
    const index = btn.getAttribute('index')
    const table = this.state.formatReport
    const isDCAP= isDCAPRadioId(table[index]?.device_id ?? '') || table[index]?.type === 'DCAP'
    isDCAP ? this.setState({dcapModal:true}) : this.setState({swapDevice:index, swapModal: true})
  }
  async onSwapHide (ok, newdevice, commissioned) {
    if (ok) {
      await this.swap (newdevice, commissioned)
    }
    this.setState({swapDevice: undefined, swapModal: false})
  }
  async onSwapDcap (ok=false, newAC=undefined) {
    if (ok) {
      const url = urlSwapDcap(newAC, siteAccessCode(this.props.getActiveSite()))
      const result = await this.ss.apiInsertData(url)
      if (Number(result?.response?.status) > 300) {
        const err = result?.response?.data?.data?.result?.message
        this.setState({errorMsg: err ?? this.ss.getErrorMsg()})
      }
      else {
        await this.setState({errorMsg: undefined, swapComplete: true, newAC: newAC})
      }
    }
    this.setState({dcapModal: false})
  }
  onEdit(evt) {
    const btn= clickToNamedClass(evt, "actButton")
    //console.log (btn.className, btn.getAttribute('index'))
    this.setState({deviceToEdit:btn.getAttribute('index'), editModal: true})
  }
  onDecommission(evt) {
    const btn= clickToNamedClass(evt, "actButton")
    //console.log (btn.className, btn.getAttribute('index'))
    this.setState({deviceToDecommission:btn.getAttribute('index'), decommissionModal: true})
  }

  onEditHide(props) {
    if (props.refresh)
      this.refresh()
    this.setState({editModal: false})
  }

  async onDecommissionHide(newState) {
    this.setState({decommissionModal: false})

    if (newState?.refresh){
      await this.refresh()
      alert("Decommission was Successful");
    }
  }
  async newSiteNav() {
    // might need to refresh the site list?
    if (siteAccessCode(this.props.getActiveSite()) !== this.state.newAC) {
      const newSite = this.props.siteMap().get(this.state.newAC)
      if (newSite) {
        this.props.setActiveSite(newSite)   // takes time
        const resp = await this.fetchNew();
        this.setData(resp);
      }
    }
    this.setState ({swapComplete: false})
  }
  decorator (props) {
    if (isDCAPRadioId(props?.data?.device_id)){
      const site = this.props.getActiveSite();
      return ContactIndicator(siteLastContact(site))
    }
    const deviceId = props?.data?.device_id?.toUpperCase()
    const icon = this.deviceStatus?.icons.find(i=>i?.device_id?.toUpperCase() === deviceId)
    return nameToIcon(icon?.icon)
  }
  csvShowDetails () {
    this.setState ({csvDetails: true})
  }
  csvBanner () {
    if (!this.state.csvBanner)
      return ''
    return "Import File result: " + 
       (this.csvAdded+this.alreadyIn+this.csvIssue.length)+" rows processed, "+this.csvAdded+" added, "
       +this.alreadyIn+" already exist, "+this.csvIssue.length + " rejected by server "
  }
  csvMoreInfo () {
    return this.state.csvDetails ? "Rejected MDTs: " + this.csvIssue.join(", ") : ""
  }
  showImportProg () {
    if (this.state.csvInProg) {
      setTimeout(() => {
        this.showImportProg ()
      }, 500)
      if (this.csvAdded !== this.state.csvAdds)
        this.setState({csvAdds: this.csvAdded})
      return <div className="inprog">CSV Import in Progress<br/>MDTs Imported {this.csvAdded}</div>
    }
    return null
  }
  showSysInfoTable(rawData) {
    const apiProps = ["type", "device_id", "Config_As", "FQA_Date", "volt",
       "LatestLinkStatusData.LinkQuality" ]
    const colTitles = ["", "Type", "Radio Id", "Model No", "Mfg Date", "Battery", "Link Quality"]
    const titleKeys = ['icon', ...apiProps]
    const disp = rawData.map (r => 
      ({...this.state.sysCfg.find (s => r?.device_id === s?.device_id), ...r}))
    return (
      <tbody>
        <TitleRow colName={colTitles} colSeq={titleKeys} />
        {disp.map((dev, index)=>
          <RowOfChildren id={index} key={'row'+index}>
            {this.decorator({ data: dev })}
            {apiProps.map(p=> (
              <GridText value={nestedProp(dev, p)} key={p}/>))}
          </RowOfChildren>
        )}
      </tbody>
    )
  }
  showConfigTable(rawData, colNames, colSeq) {
    //determine if a device is decommissionable, DCAPS are not decommissionable
    const isDecommissionable = rawData.map(e => e?.type !== "DCAP")
    const asIsCols = [1,2,3,4,5,6,7]
    return (
    <tbody> 
      <TitleRow index={0} data={rawData[0]} colName={colNames} colSeq={colSeq} 
            graph={this.sort} colSort={this.state.colSort} 
            sortable={jsonReportCfg.data[this.reportId].sortable}/>
      {rawData.map((dev, index) =>
        <RowOfChildren id={index} key={'row'+index}>
          {this.decorator({ data: dev })}
          {asIsCols.map(i=> (
            <GridText value={dev[colSeq[i]]} key={i}/>))}
            <GridAction id='action' index={index} wrap="act-column" key="actions"
              onEdit={this.canEdit() ? this.onEdit : null} 
              onRemove={this.canEdit() && isDecommissionable[index] ? this.onDecommission : null}
              onSwap={this.canEdit() ? this.onSwap : null}/>
        </RowOfChildren>
      )}
    </tbody>
    )
  }
  showConfig() {
    if (this.state.isLoading) {
      return (
        <div className="wait-top-margin">
          {this.state.csvInProg? this.showImportProg(): this.state.loader}
        </div>
      )
    }
    if(this.state.swapComplete) {
      return ( 
        <div className="table-container">
          <Popup onClose={this.newSiteNav} popupStyle='light' popupMsg="Swap complete. Close this popup to view the new site"/>
        </div>)
    }
    if (!this.state.formatReport) {
      return (<TryAgain details={"showConfig: Have no data"}/>)
    }
    if (this.state.formatReport?.length === 0) {
      return (<NoResults displayText="No devices found."/>);
    }
    const csvBanner = this.csvBanner()
    const rawData = this.state.formatReport
    const reportId = this.reportId; 
    const tableId = "dispTable";
    const colSeq = jsonReportCfg.data[reportId].displayOrder;
    const colNames = jsonReportCfg.data[reportId].displayName;
    const csvLink = (this.csvIssue.length && this.state.csvDetails === false) ? 'More Info' :null
    const csvRejects = this.csvMoreInfo()
    const csvErrDetails = this.state.csvErr ? 
      "An unexpected error occurred during CSV processing. Details: "+this.state.csvErrMsg : ''
   return(
      <div className="table-container">
      <Popup onClose={this.csvClearErr} popupMsg={csvErrDetails} />
      <Popup onClose={this.csvDone} popupMsg={csvBanner} link={csvLink} moreinfo={this.csvShowDetails}
        details={csvRejects}/>
      <Popup onClose={this.confirmed} popupMsg={this.state.errorMsg} />
      <table className="csv-table config-table" id={tableId}>
        {this.state.sysInfo ? this.showSysInfoTable(rawData) : 
          this.showConfigTable(rawData, colNames, colSeq)}
      </table>
      <br />
    </div>
    )
  }
  sysInfo = () => {
    this.setState({sysInfo: !this.state.sysInfo})
  }
  canEdit() {
    return canWrite(cachedPerms(this.props.getActiveSite()))
  }
  buttonBar () {
    if (this.canEdit()) {
      return (
        <ButtonBar2 {...this.props} site={this.state.siteDetails} csvClick={this.exportController} 
          FileImport={this.importToggle} onUpdate={this.refresh} details={this.sysInfo}
          onSwap={this.swap} isCommissioned={this.isCommissioned}/>
      )           
    }
    else return (
      <div className='button-row2'>
        <CsvButton5 {...this.props} csvClick={this.exportController} />
      </div>
    )
  }
  render() {
    try {
      const table = this.state.formatReport
      const editData = this.state.deviceToEdit ? table[this.state.deviceToEdit] : undefined
      const swapData = this.state.swapDevice ? table[this.state.swapDevice] : undefined
      const decommissionData = this.state.deviceToDecommission ? table[this.state.deviceToDecommission] : undefined
      const ac = siteAccessCode(this.props.getActiveSite())
      return (
        <div>
          <div className="control-row">
            <Search onChange={this.filter}>
              <FilterRender />
            </Search>
            {this.buttonBar()}
          </div>
          <FileImport controller={this.importController} />
          <DeviceEdit {...this.props} deviceId={editData?.device_id} onHide={this.onEditHide}
                    show={this.state.editModal} objMap={this.deviceEditMap} meta={editData}/>
          <DeviceDecommission {...this.props} deviceId={decommissionData?.device_id} onHide={this.onDecommissionHide}
                    show={this.state.decommissionModal} objMap={this.deviceDecommissionMap} meta={decommissionData}/>
          <SwapDevice {...this.props} devices={[swapData]} show={this.state.swapModal} onHide={this.onSwapHide}/>
          <SwapDCAP {...this.props} device={ac} show={this.state.dcapModal} onHide={this.onSwapDcap}/>
          {this.showConfig()}
        </div>
      )
    }
    catch (e) {
      console.log (e)
      console.trace()
      return (<TryAgain details={"Config.render: "+e.toString()} />)
    }
  }
}
//csvClick={csvDownload} csvTable={this.tableId}
